import { useMemo } from 'react';

/**
 * Custom hook to calculate the number of active filters
 * Excludes pagination and core search/ordering parameters
 */
const useFiltersCount = (searchParams: Record<string, unknown>) => {
  const filtersCount = useMemo(() => {
    let count = 0;
    for (const key in searchParams) {
      if (
        ['page', 'pageSize', 'ordering', 'search'].includes(key) ||
        searchParams[key] === undefined
      ) {
        continue;
      }

      count++;
    }
    return count;
  }, [searchParams]);

  return filtersCount;
};

export default useFiltersCount;
